// src/pages/FaqPage.jsx
import React, { useState, useCallback } from "react";
import "../styles/faq.css";

const FAQS = [
  {
    q: "물이 무서운데 할 수 있을까요?",
    a: `프리다이빙은 숨을 참고 도구를 이용해 잠수하는 활동입니다.
숨 참는 법을 배우시면 깊은 물에 대한 공포는 어느 정도 이겨낼 수 있습니다.`,
  },
  {
    q: "수영을 잘 못하고, 숨을 참기 어려운데 가능한가요?",
    a: `수영을 잘 못해도 물에 뜨는 법부터 익혀 누구나 시작할 수 있습니다.
처음엔 얕은 곳에서 호흡법, 릴랙스, 균형 잡기부터 배우고 점차 깊이를 늘려 갑니다.
숨 참기가 어려운 이유가 숨에 억지로 힘이 들어가거나 생각나서 나오는 반응인 경우가 많아
호흡/릴랙스 훈련을 통해 충분히 개선됩니다.`,
  },
  {
    q: "프리다이빙과 스쿠버다이빙은 어떤 점이 다른가요?",
    a: `스쿠버다이빙은 공기통과 장비를 사용해 수중에서 둘러보는 것을 즐기는 해양 레저고,
프리다이빙은 오롯이 내 호흡을 활용해 자유롭게 유영하는 수중 스포츠입니다.`,
  },
  {
    q: "친구나 커플끼리 같이 배울 수 있을까요?",
    a: `모든 사람과 단체 참여 대신 '친구/커플/가족' 소수팀 위주로 운영하고 있습니다.`,
  },
  {
    q: "혼자서도 참여 가능한가요?",
    a: `물론 가능합니다. 많은 분들이 혼자 등록하시고도 금방 친해지십니다.
현장에서 버디 매칭도 도와드리고, 1:1 개인 코칭 과정도 있어요.`,
  },
  {
    q: "장비를 구입해야 하나요?",
    a: `장비는 전 과정에서 대여 가능합니다. (마스크, 스노클, 핀, 슈트 대여 가능)`,
  },
  {
    q: "준비물은 무엇이 필요한가요?",
    a: `수영복, 수건, 여벌의 옷/슬리퍼. 수영장에 따라 수모/세면도구가 필요할 수 있습니다.`,
  },
];

export default function FaqPage() {
  // 여러 항목을 독립적으로 펼칠 수 있도록 Set 사용
  const [openSet, setOpenSet] = useState(() => new Set());

  const toggle = useCallback((idx) => {
    setOpenSet((prev) => {
      const next = new Set(prev);
      if (next.has(idx)) next.delete(idx);
      else next.add(idx);
      return next;
    });
  }, []);

  return (
    <div className="faq-page">
      <section className="faq-header">
        <div className="container">
          <h2>자주묻는 질문</h2>
          <p>
            자주찾는 질문으로 궁금증을 해결해 보세요.
            <br />
            궁금증이 해소되지 않는다면 강습 문의를 이용해 주세요.
          </p>
        </div>
      </section>

      <section className="faq-section">
        <div className="container">
          <div className="faq-list">
            {FAQS.map((it, i) => {
              const isOpen = openSet.has(i);
              const lines = it.a.split("\n");
              const lastIdx = lines.length - 1;

              return (
                <div key={i} className={`faq-item ${isOpen ? "is-open" : ""}`}>
                  <button
                    type="button"
                    className="faq-q"
                    aria-expanded={isOpen}
                    aria-controls={`faq-panel-${i}`}
                    id={`faq-button-${i}`}
                    onClick={() => toggle(i)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        toggle(i);
                      }
                    }}
                  >
                    <span className="qa-ic">Q.</span>
                    <span className="q-text">{it.q}</span>
                    {/* 아이콘은 CSS ::before 로 구현 (닫힘: ⌄ / 열림: ⌃) */}
                    <span className="chev" aria-hidden="true" />
                  </button>

                  {isOpen && (
                    <div
                      id={`faq-panel-${i}`}
                      role="region"
                      aria-labelledby={`faq-button-${i}`}
                      className="faq-a"
                    >
                      <span className="qa-ic">A.</span>
                      <p className="a-text">
                        {lines.map((line, idx) => (
                          <span key={idx}>
                            {line}
                            {idx < lastIdx && <br />}
                          </span>
                        ))}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
}
